module.exports = __webpack_public_path__ + "img/account-icon.aabca33e.svg";